import { isoToFaName } from '@/constants/iso-to-fa-name.constant'

export const getCountryFaName = (iso?: string | null): string => {
  if (!iso) return '-'

  return isoToFaName[iso.toUpperCase()] ?? '-'
}
